import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { PropsWithChildren } from 'react';
import { FEATURE_FLAGS } from '../../constant/featureFlags';
import IfFeatureEnabledMSR3 from '../IfFeatureEnabledMSR3';
import ProtectElement from '../ProtectElement';

/**
 * Flag first, then permission — a permission-only gate renders a link that
 * dead-ends while the route answers not-found.
 */
export const NotificationsNavGate = ({ children }: PropsWithChildren) => (
  <IfFeatureEnabledMSR3 name={FEATURE_FLAGS.MSR3_NOTIFICATIONS_ROUTE}>
    <ProtectElement permissionRequired={[PermissionEnum.ViewNotificationFeed]}>
      {children}
    </ProtectElement>
  </IfFeatureEnabledMSR3>
);
